import { render, staticRenderFns } from "./singleMainContainer.vue.html?vue&type=template&id=74489e31&"
import script from "./singleMainContainer.ts?vue&type=script&lang=ts&"
export * from "./singleMainContainer.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports